import * as Yup from "yup";

export default Yup.object().shape({
  newslatter: Yup.boolean()
    .oneOf([true], "Súhlas s podmienkami je povinný")
    .required("Súhlas je povinný")
});
